<template>
	<div class="d-flex flex-fill">
		<b-list-group style="overflow-y: scroll; height:258px" class="d-flex flex-fill">
			<b-list-group-item class="flex-column align-items-start p-2" v-for="item in items" v-bind:key="item.id">
				<div class="d-flex w-100 justify-content-between">
					<h6 class="mb-0">{{item.name}}</h6>
					<small>{{item.updatedTimestamp | since }}</small>
				</div>
				<p class="text-monospace">{{item.query | ellipsis(50)}}</p>
				<div class="d-flex w-100 justify-content-between">
					<small>{{item.description}}</small>
					<span>
						<b-button variant="link" class="m-0 p-0" @click="deleteQuery(item.id)" v-b-tooltip.hover title="Delete this query"><icon name="trash" style="color: 777"></icon></b-button>
						<b-button variant="link" class="m-0 p-0" @click="copyQuery(item)" v-b-tooltip.hover title="Copy the query into the workbench"><icon name="clone" style="color: 777"></icon></b-button>
						<b-button variant="link" class="m-0 p-0" @click="executeQuery(item)" v-b-tooltip.hover title="Execute this query"><icon name="play" style="color: 777"></icon></b-button>
					</span>
				</div>
			</b-list-group-item>
		</b-list-group>
	</div>
</template>

<script>
import {HTTP} from '../services/HttpService'

export default {
  name: 'saved-queries',
  props: {
    username: String
  },
  data () {
    return {
      fields: [],
      items: [],
      pageNo: 1,
      totalRows: 0,
      rowsPerPage: 20
    }
  },
  mounted: function () {
  },
  methods: {
    pageChange () {
      HTTP.get('api/queries', {
        params: {
          page: this.pageNo - 1,
          rowsPerPage: this.rowsPerPage
        }
      })
      .then(response => {
        this.items = response.data.list
        this.rowsPerPage = response.data.rowsPerPage
        this.totalItems = response.data.totalItems
      })
    },
    deleteQuery (queryId) {
      HTTP.delete('api/queries/' + queryId)
      .then(response => {
        this.pageChange()
      })
    },
    executeQuery (item) {
      console.log(item)
      this.$emit('executeQuery', item)
    },
    copyQuery (item) {
      console.log(item)
      this.$emit('copyQuery', item)
    }
  },
  created () {
    this.pageChange()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// SavedQueries.vue?1ea0a196